import _construct from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/construct.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import firebase from '@firebase/app-compat';
import { FirestoreError, Bytes, _isBase64Available, enableIndexedDbPersistence as _enableIndexedDbPersistence, enableMultiTabIndexedDbPersistence as _enableMultiTabIndexedDbPersistence, clearIndexedDbPersistence as _clearIndexedDbPersistence, _DatabaseId, _logWarn, connectFirestoreEmulator, enableNetwork as _enableNetwork, disableNetwork as _disableNetwork, _validateIsNotUsedTogether, waitForPendingWrites as _waitForPendingWrites, onSnapshotsInSync as _onSnapshotsInSync, collection as _collection, doc as _doc, collectionGroup as _collectionGroup, runTransaction as _runTransaction, ensureFirestoreConfigured, WriteBatch as WriteBatch$1, executeWrite, loadBundle as _loadBundle, namedQuery as _namedQuery, DocumentSnapshot as DocumentSnapshot$1, DocumentReference as DocumentReference$1, _DocumentKey, refEqual, setDoc, updateDoc, deleteDoc, onSnapshot as _onSnapshot, getDocFromCache, getDocFromServer, getDoc, snapshotEqual, query, where as _where, orderBy as _orderBy, limit as _limit, limitToLast as _limitToLast, startAt as _startAt, startAfter as _startAfter, endBefore as _endBefore, endAt as _endAt, queryEqual, getDocsFromCache, getDocsFromServer, getDocs, QuerySnapshot as QuerySnapshot$1, addDoc, _cast, AbstractUserDataWriter, setLogLevel as setLogLevel$1, QueryDocumentSnapshot as QueryDocumentSnapshot$1, _debugAssert, FieldPath as FieldPath$1, _FieldPath, serverTimestamp as _serverTimestamp, deleteField, arrayUnion as _arrayUnion, arrayRemove as _arrayRemove, increment as _increment, GeoPoint, Timestamp, CACHE_SIZE_UNLIMITED } from '@firebase/firestore';
import { getModularInstance } from '@firebase/util';
import { Component } from '@firebase/component';
var name = "@firebase/firestore-compat";
var version = "0.3.9";

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function validateSetOptions(methodName, options) {
  if (options === undefined) {
    return {
      merge: false
    };
  }
  if (options.mergeFields !== undefined && options.merge !== undefined) {
    throw new FirestoreError('invalid-argument', "Invalid options passed to function ".concat(methodName, "(): You cannot ") + 'specify both "merge" and "mergeFields".');
  }
  return options;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Helper function to assert Uint8Array is available at runtime. */
function assertUint8ArrayAvailable() {
  if (typeof Uint8Array === 'undefined') {
    throw new FirestoreError('unimplemented', 'Uint8Arrays are not available in this environment.');
  }
}
/** Helper function to assert Base64 functions are available at runtime. */
function assertBase64Available() {
  if (!_isBase64Available()) {
    throw new FirestoreError('unimplemented', 'Blobs are unavailable in Firestore in this environment.');
  }
}
/** Immutable class holding a blob (binary data) */
var Blob = /*#__PURE__*/function () {
  function Blob(_delegate) {
    _classCallCheck(this, Blob);
    this._delegate = _delegate;
  }
  _createClass(Blob, [{
    key: "toBase64",
    value: function toBase64() {
      assertBase64Available();
      return this._delegate.toBase64();
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      assertUint8ArrayAvailable();
      return this._delegate.toUint8Array();
    }
  }, {
    key: "isEqual",
    value: function isEqual(other) {
      return this._delegate.isEqual(other._delegate);
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'Blob(base64: ' + this.toBase64() + ')';
    }
  }], [{
    key: "fromBase64String",
    value: function fromBase64String(base64) {
      assertBase64Available();
      return new Blob(Bytes.fromBase64String(base64));
    }
  }, {
    key: "fromUint8Array",
    value: function fromUint8Array(array) {
      assertUint8ArrayAvailable();
      return new Blob(Bytes.fromUint8Array(array));
    }
  }]);
  return Blob;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isPartialObserver(obj) {
  return implementsAnyMethods(obj, ['next', 'error', 'complete']);
}
/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */
function implementsAnyMethods(obj, methods) {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }
  var object = obj;
  var _iterator = _createForOfIteratorHelper(methods),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var method = _step.value;
      if (method in object && typeof object[method] === 'function') {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The persistence provider included with the full Firestore SDK.
 */
var IndexedDbPersistenceProvider = /*#__PURE__*/function () {
  function IndexedDbPersistenceProvider() {
    _classCallCheck(this, IndexedDbPersistenceProvider);
  }
  _createClass(IndexedDbPersistenceProvider, [{
    key: "enableIndexedDbPersistence",
    value: function enableIndexedDbPersistence(firestore, forceOwnership) {
      return _enableIndexedDbPersistence(firestore._delegate, {
        forceOwnership: forceOwnership
      });
    }
  }, {
    key: "enableMultiTabIndexedDbPersistence",
    value: function enableMultiTabIndexedDbPersistence(firestore) {
      return _enableMultiTabIndexedDbPersistence(firestore._delegate);
    }
  }, {
    key: "clearIndexedDbPersistence",
    value: function clearIndexedDbPersistence(firestore) {
      return _clearIndexedDbPersistence(firestore._delegate);
    }
  }]);
  return IndexedDbPersistenceProvider;
}();
/**
 * Compat class for Firestore. Exposes Firestore Legacy API, but delegates
 * to the functional API of firestore-exp.
 */
var Firestore = /*#__PURE__*/function () {
  function Firestore(databaseIdOrApp, _delegate, _persistenceProvider) {
    var _this = this;
    _classCallCheck(this, Firestore);
    this._delegate = _delegate;
    this._persistenceProvider = _persistenceProvider;
    this.INTERNAL = {
      delete: function _delete() {
        return _this.terminate();
      }
    };
    if (!(databaseIdOrApp instanceof _DatabaseId)) {
      this._appCompat = databaseIdOrApp;
    }
  }
  _createClass(Firestore, [{
    key: "_databaseId",
    get: function get() {
      return this._delegate._databaseId;
    }
  }, {
    key: "settings",
    value: function settings(settingsLiteral) {
      var currentSettings = this._delegate._getSettings();
      if (!settingsLiteral.merge && currentSettings.host !== settingsLiteral.host) {
        _logWarn('You are overriding the original host. If you did not intend ' + 'to override your settings, use {merge: true}.');
      }
      if (settingsLiteral.merge) {
        settingsLiteral = Object.assign(Object.assign({}, currentSettings), settingsLiteral);
        // Remove the property from the settings once the merge is completed
        delete settingsLiteral.merge;
      }
      this._delegate._setSettings(settingsLiteral);
    }
  }, {
    key: "useEmulator",
    value: function useEmulator(host, port) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      connectFirestoreEmulator(this._delegate, host, port, options);
    }
  }, {
    key: "enableNetwork",
    value: function enableNetwork() {
      return _enableNetwork(this._delegate);
    }
  }, {
    key: "disableNetwork",
    value: function disableNetwork() {
      return _disableNetwork(this._delegate);
    }
  }, {
    key: "enablePersistence",
    value: function enablePersistence(settings) {
      var synchronizeTabs = false;
      var experimentalForceOwningTab = false;
      if (settings) {
        synchronizeTabs = !!settings.synchronizeTabs;
        experimentalForceOwningTab = !!settings.experimentalForceOwningTab;
        _validateIsNotUsedTogether('synchronizeTabs', synchronizeTabs, 'experimentalForceOwningTab', experimentalForceOwningTab);
      }
      return synchronizeTabs ? this._persistenceProvider.enableMultiTabIndexedDbPersistence(this) : this._persistenceProvider.enableIndexedDbPersistence(this, experimentalForceOwningTab);
    }
  }, {
    key: "clearPersistence",
    value: function clearPersistence() {
      return this._persistenceProvider.clearIndexedDbPersistence(this);
    }
  }, {
    key: "terminate",
    value: function terminate() {
      if (this._appCompat) {
        this._appCompat._removeServiceInstance('firestore-compat');
        this._appCompat._removeServiceInstance('firestore');
      }
      return this._delegate._delete();
    }
  }, {
    key: "waitForPendingWrites",
    value: function waitForPendingWrites() {
      return _waitForPendingWrites(this._delegate);
    }
  }, {
    key: "onSnapshotsInSync",
    value: function onSnapshotsInSync(arg) {
      return _onSnapshotsInSync(this._delegate, arg);
    }
  }, {
    key: "app",
    get: function get() {
      if (!this._appCompat) {
        throw new FirestoreError('failed-precondition', "Firestore was not initialized using the Firebase SDK. 'app' is " + 'not available');
      }
      return this._appCompat;
    }
  }, {
    key: "collection",
    value: function collection(pathString) {
      try {
        return new CollectionReference(this, _collection(this._delegate, pathString));
      } catch (e) {
        throw replaceFunctionName(e, 'collection()', 'Firestore.collection()');
      }
    }
  }, {
    key: "doc",
    value: function doc(pathString) {
      try {
        return new DocumentReference(this, _doc(this._delegate, pathString));
      } catch (e) {
        throw replaceFunctionName(e, 'doc()', 'Firestore.doc()');
      }
    }
  }, {
    key: "collectionGroup",
    value: function collectionGroup(collectionId) {
      try {
        return new Query(this, _collectionGroup(this._delegate, collectionId));
      } catch (e) {
        throw replaceFunctionName(e, 'collectionGroup()', 'Firestore.collectionGroup()');
      }
    }
  }, {
    key: "runTransaction",
    value: function runTransaction(updateFunction) {
      var _this2 = this;
      return _runTransaction(this._delegate, function (transaction) {
        return updateFunction(new Transaction(_this2, transaction));
      });
    }
  }, {
    key: "batch",
    value: function batch() {
      var _this3 = this;
      ensureFirestoreConfigured(this._delegate);
      return new WriteBatch(new WriteBatch$1(this._delegate, function (mutations) {
        return executeWrite(_this3._delegate, mutations);
      }));
    }
  }, {
    key: "loadBundle",
    value: function loadBundle(bundleData) {
      return _loadBundle(this._delegate, bundleData);
    }
  }, {
    key: "namedQuery",
    value: function namedQuery(name) {
      var _this4 = this;
      return _namedQuery(this._delegate, name).then(function (expQuery) {
        if (!expQuery) {
          return null;
        }
        return new Query(_this4,
        // We can pass `expQuery` here directly since named queries don't have a UserDataConverter.
        // Otherwise, we would have to create a new ExpQuery and pass the old UserDataConverter.
        expQuery);
      });
    }
  }]);
  return Firestore;
}();
var UserDataWriter = /*#__PURE__*/function (_AbstractUserDataWrit) {
  _inherits(UserDataWriter, _AbstractUserDataWrit);
  var _super = _createSuper(UserDataWriter);
  function UserDataWriter(firestore) {
    var _this5;
    _classCallCheck(this, UserDataWriter);
    _this5 = _super.call(this);
    _this5.firestore = firestore;
    return _this5;
  }
  _createClass(UserDataWriter, [{
    key: "convertBytes",
    value: function convertBytes(bytes) {
      return new Blob(new Bytes(bytes));
    }
  }, {
    key: "convertReference",
    value: function convertReference(name) {
      var key = this.convertDocumentKey(name, this.firestore._databaseId);
      return DocumentReference.forKey(key, this.firestore, /* converter= */null);
    }
  }]);
  return UserDataWriter;
}(AbstractUserDataWriter);
function setLogLevel(level) {
  setLogLevel$1(level);
}
/**
 * A reference to a transaction.
 */
var Transaction = /*#__PURE__*/function () {
  function Transaction(_firestore, _delegate) {
    _classCallCheck(this, Transaction);
    this._firestore = _firestore;
    this._delegate = _delegate;
    this._userDataWriter = new UserDataWriter(_firestore);
  }
  _createClass(Transaction, [{
    key: "get",
    value: function get(documentRef) {
      var _this6 = this;
      var ref = castReference(documentRef);
      return this._delegate.get(ref).then(function (result) {
        return new DocumentSnapshot(_this6._firestore, new DocumentSnapshot$1(_this6._firestore._delegate, _this6._userDataWriter, result._key, result._document, result.metadata, ref.converter));
      });
    }
  }, {
    key: "set",
    value: function set(documentRef, data, options) {
      var ref = castReference(documentRef);
      if (options) {
        validateSetOptions('Transaction.set', options);
        this._delegate.set(ref, data, options);
      } else {
        this._delegate.set(ref, data);
      }
      return this;
    }
  }, {
    key: "update",
    value: function update(documentRef, dataOrField, value) {
      for (var _len = arguments.length, moreFieldsAndValues = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        moreFieldsAndValues[_key - 3] = arguments[_key];
      }
      var ref = castReference(documentRef);
      if (arguments.length === 2) {
        this._delegate.update(ref, dataOrField);
      } else {
        var _this$_delegate;
        (_this$_delegate = this._delegate).update.apply(_this$_delegate, [ref, dataOrField, value].concat(moreFieldsAndValues));
      }
      return this;
    }
  }, {
    key: "delete",
    value: function _delete(documentRef) {
      var ref = castReference(documentRef);
      this._delegate.delete(ref);
      return this;
    }
  }]);
  return Transaction;
}();
var WriteBatch = /*#__PURE__*/function () {
  function WriteBatch(_delegate) {
    _classCallCheck(this, WriteBatch);
    this._delegate = _delegate;
  }
  _createClass(WriteBatch, [{
    key: "set",
    value: function set(documentRef, data, options) {
      var ref = castReference(documentRef);
      if (options) {
        validateSetOptions('WriteBatch.set', options);
        this._delegate.set(ref, data, options);
      } else {
        this._delegate.set(ref, data);
      }
      return this;
    }
  }, {
    key: "update",
    value: function update(documentRef, dataOrField, value) {
      for (var _len2 = arguments.length, moreFieldsAndValues = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        moreFieldsAndValues[_key2 - 3] = arguments[_key2];
      }
      var ref = castReference(documentRef);
      if (arguments.length === 2) {
        this._delegate.update(ref, dataOrField);
      } else {
        var _this$_delegate2;
        (_this$_delegate2 = this._delegate).update.apply(_this$_delegate2, [ref, dataOrField, value].concat(moreFieldsAndValues));
      }
      return this;
    }
  }, {
    key: "delete",
    value: function _delete(documentRef) {
      var ref = castReference(documentRef);
      this._delegate.delete(ref);
      return this;
    }
  }, {
    key: "commit",
    value: function commit() {
      return this._delegate.commit();
    }
  }]);
  return WriteBatch;
}();
/**
 * Wraps a `PublicFirestoreDataConverter` translating the types from the
 * experimental SDK into corresponding types from the Classic SDK before passing
 * them to the wrapped converter.
 */
var FirestoreDataConverter = /*#__PURE__*/function () {
  function FirestoreDataConverter(_firestore, _userDataWriter, _delegate) {
    _classCallCheck(this, FirestoreDataConverter);
    this._firestore = _firestore;
    this._userDataWriter = _userDataWriter;
    this._delegate = _delegate;
  }
  _createClass(FirestoreDataConverter, [{
    key: "fromFirestore",
    value: function fromFirestore(snapshot, options) {
      var expSnapshot = new QueryDocumentSnapshot$1(this._firestore._delegate, this._userDataWriter, snapshot._key, snapshot._document, snapshot.metadata, /* converter= */null);
      return this._delegate.fromFirestore(new QueryDocumentSnapshot(this._firestore, expSnapshot), options !== null && options !== void 0 ? options : {});
    }
  }, {
    key: "toFirestore",
    value: function toFirestore(modelObject, options) {
      if (!options) {
        return this._delegate.toFirestore(modelObject);
      } else {
        return this._delegate.toFirestore(modelObject, options);
      }
    }
    // Use the same instance of `FirestoreDataConverter` for the given instances
    // of `Firestore` and `PublicFirestoreDataConverter` so that isEqual() will
    // compare equal for two objects created with the same converter instance.
  }], [{
    key: "getInstance",
    value: function getInstance(firestore, converter) {
      var converterMapByFirestore = FirestoreDataConverter.INSTANCES;
      var untypedConverterByConverter = converterMapByFirestore.get(firestore);
      if (!untypedConverterByConverter) {
        untypedConverterByConverter = new WeakMap();
        converterMapByFirestore.set(firestore, untypedConverterByConverter);
      }
      var instance = untypedConverterByConverter.get(converter);
      if (!instance) {
        instance = new FirestoreDataConverter(firestore, new UserDataWriter(firestore), converter);
        untypedConverterByConverter.set(converter, instance);
      }
      return instance;
    }
  }]);
  return FirestoreDataConverter;
}();
FirestoreDataConverter.INSTANCES = new WeakMap();
/**
 * A reference to a particular document in a collection in the database.
 */
var DocumentReference = /*#__PURE__*/function () {
  function DocumentReference(firestore, _delegate) {
    _classCallCheck(this, DocumentReference);
    this.firestore = firestore;
    this._delegate = _delegate;
    this._userDataWriter = new UserDataWriter(firestore);
  }
  _createClass(DocumentReference, [{
    key: "id",
    get: function get() {
      return this._delegate.id;
    }
  }, {
    key: "parent",
    get: function get() {
      return new CollectionReference(this.firestore, this._delegate.parent);
    }
  }, {
    key: "path",
    get: function get() {
      return this._delegate.path;
    }
  }, {
    key: "collection",
    value: function collection(pathString) {
      try {
        return new CollectionReference(this.firestore, _collection(this._delegate, pathString));
      } catch (e) {
        throw replaceFunctionName(e, 'collection()', 'DocumentReference.collection()');
      }
    }
  }, {
    key: "isEqual",
    value: function isEqual(other) {
      other = getModularInstance(other);
      if (!(other instanceof DocumentReference$1)) {
        return false;
      }
      return refEqual(this._delegate, other);
    }
  }, {
    key: "set",
    value: function set(value, options) {
      options = validateSetOptions('DocumentReference.set', options);
      try {
        if (options) {
          return setDoc(this._delegate, value, options);
        } else {
          return setDoc(this._delegate, value);
        }
      } catch (e) {
        throw replaceFunctionName(e, 'setDoc()', 'DocumentReference.set()');
      }
    }
  }, {
    key: "update",
    value: function update(fieldOrUpdateData, value) {
      for (var _len3 = arguments.length, moreFieldsAndValues = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        moreFieldsAndValues[_key3 - 2] = arguments[_key3];
      }
      try {
        if (arguments.length === 1) {
          return updateDoc(this._delegate, fieldOrUpdateData);
        } else {
          return updateDoc.apply(void 0, [this._delegate, fieldOrUpdateData, value].concat(moreFieldsAndValues));
        }
      } catch (e) {
        throw replaceFunctionName(e, 'updateDoc()', 'DocumentReference.update()');
      }
    }
  }, {
    key: "delete",
    value: function _delete() {
      return deleteDoc(this._delegate);
    }
  }, {
    key: "onSnapshot",
    value: function onSnapshot() {
      var _this7 = this;
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var options = extractSnapshotOptions(args);
      var observer = wrapObserver(args, function (result) {
        return new DocumentSnapshot(_this7.firestore, new DocumentSnapshot$1(_this7.firestore._delegate, _this7._userDataWriter, result._key, result._document, result.metadata, _this7._delegate.converter));
      });
      return _onSnapshot(this._delegate, options, observer);
    }
  }, {
    key: "get",
    value: function get(options) {
      var _this8 = this;
      var snap;
      if ((options === null || options === void 0 ? void 0 : options.source) === 'cache') {
        snap = getDocFromCache(this._delegate);
      } else if ((options === null || options === void 0 ? void 0 : options.source) === 'server') {
        snap = getDocFromServer(this._delegate);
      } else {
        snap = getDoc(this._delegate);
      }
      return snap.then(function (result) {
        return new DocumentSnapshot(_this8.firestore, new DocumentSnapshot$1(_this8.firestore._delegate, _this8._userDataWriter, result._key, result._document, result.metadata, _this8._delegate.converter));
      });
    }
  }, {
    key: "withConverter",
    value: function withConverter(converter) {
      return new DocumentReference(this.firestore, converter ? this._delegate.withConverter(FirestoreDataConverter.getInstance(this.firestore, converter)) : this._delegate.withConverter(null));
    }
  }], [{
    key: "forPath",
    value: function forPath(path, firestore, converter) {
      if (path.length % 2 !== 0) {
        throw new FirestoreError('invalid-argument', 'Invalid document reference. Document ' + 'references must have an even number of segments, but ' + "".concat(path.canonicalString(), " has ").concat(path.length));
      }
      return new DocumentReference(firestore, new DocumentReference$1(firestore._delegate, converter, new _DocumentKey(path)));
    }
  }, {
    key: "forKey",
    value: function forKey(key, firestore, converter) {
      return new DocumentReference(firestore, new DocumentReference$1(firestore._delegate, converter, key));
    }
  }]);
  return DocumentReference;
}();
/**
 * Replaces the function name in an error thrown by the firestore-exp API
 * with the function names used in the classic API.
 */
function replaceFunctionName(e, original, updated) {
  e.message = e.message.replace(original, updated);
  return e;
}
/**
 * Iterates the list of arguments from an `onSnapshot` call and returns the
 * first argument that may be an `SnapshotListenOptions` object. Returns an
 * empty object if none is found.
 */
function extractSnapshotOptions(args) {
  var _iterator2 = _createForOfIteratorHelper(args),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var arg = _step2.value;
      if (typeof arg === 'object' && !isPartialObserver(arg)) {
        return arg;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {};
}
/**
 * Creates an observer that can be passed to the firestore-exp SDK. The
 * observer converts all observed values into the format expected by the classic
 * SDK.
 *
 * @param args - The list of arguments from an `onSnapshot` call.
 * @param wrapper - The function that converts the firestore-exp type into the
 * type used by this shim.
 */
function wrapObserver(args, wrapper) {
  var _a, _b;
  var userObserver;
  if (isPartialObserver(args[0])) {
    userObserver = args[0];
  } else if (isPartialObserver(args[1])) {
    userObserver = args[1];
  } else if (typeof args[0] === 'function') {
    userObserver = {
      next: args[0],
      error: args[1],
      complete: args[2]
    };
  } else {
    userObserver = {
      next: args[1],
      error: args[2],
      complete: args[3]
    };
  }
  return {
    next: function next(val) {
      if (userObserver.next) {
        userObserver.next(wrapper(val));
      }
    },
    error: (_a = userObserver.error) === null || _a === void 0 ? void 0 : _a.bind(userObserver),
    complete: (_b = userObserver.complete) === null || _b === void 0 ? void 0 : _b.bind(userObserver)
  };
}
var DocumentSnapshot = /*#__PURE__*/function () {
  function DocumentSnapshot(_firestore, _delegate) {
    _classCallCheck(this, DocumentSnapshot);
    this._firestore = _firestore;
    this._delegate = _delegate;
  }
  _createClass(DocumentSnapshot, [{
    key: "ref",
    get: function get() {
      return new DocumentReference(this._firestore, this._delegate.ref);
    }
  }, {
    key: "id",
    get: function get() {
      return this._delegate.id;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this._delegate.metadata;
    }
  }, {
    key: "exists",
    get: function get() {
      return this._delegate.exists();
    }
  }, {
    key: "data",
    value: function data(options) {
      return this._delegate.data(options);
    }
  }, {
    key: "get",
    value: function get(fieldPath, options
    // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return this._delegate.get(fieldPath, options);
    }
  }, {
    key: "isEqual",
    value: function isEqual(other) {
      return snapshotEqual(this._delegate, other._delegate);
    }
  }]);
  return DocumentSnapshot;
}();
var QueryDocumentSnapshot = /*#__PURE__*/function (_DocumentSnapshot) {
  _inherits(QueryDocumentSnapshot, _DocumentSnapshot);
  var _super2 = _createSuper(QueryDocumentSnapshot);
  function QueryDocumentSnapshot() {
    _classCallCheck(this, QueryDocumentSnapshot);
    return _super2.apply(this, arguments);
  }
  _createClass(QueryDocumentSnapshot, [{
    key: "data",
    value: function data(options) {
      var data = this._delegate.data(options);
      _debugAssert(data !== undefined, 'Document in a QueryDocumentSnapshot should exist');
      return data;
    }
  }]);
  return QueryDocumentSnapshot;
}(DocumentSnapshot);
var Query = /*#__PURE__*/function () {
  function Query(firestore, _delegate) {
    _classCallCheck(this, Query);
    this.firestore = firestore;
    this._delegate = _delegate;
    this._userDataWriter = new UserDataWriter(firestore);
  }
  _createClass(Query, [{
    key: "where",
    value: function where(fieldPath, opStr, value) {
      try {
        // The "as string" cast is a little bit of a hack. `where` accepts the
        // FieldPath Compat type as input, but is not typed as such in order to
        // not expose this via our public typings file.
        return new Query(this.firestore, query(this._delegate, _where(fieldPath, opStr, value)));
      } catch (e) {
        throw replaceFunctionName(e, /(orderBy|where)\(\)/, 'Query.$1()');
      }
    }
  }, {
    key: "orderBy",
    value: function orderBy(fieldPath, directionStr) {
      try {
        // The "as string" cast is a little bit of a hack. `orderBy` accepts the
        // FieldPath Compat type as input, but is not typed as such in order to
        // not expose this via our public typings file.
        return new Query(this.firestore, query(this._delegate, _orderBy(fieldPath, directionStr)));
      } catch (e) {
        throw replaceFunctionName(e, /(orderBy|where)\(\)/, 'Query.$1()');
      }
    }
  }, {
    key: "limit",
    value: function limit(n) {
      try {
        return new Query(this.firestore, query(this._delegate, _limit(n)));
      } catch (e) {
        throw replaceFunctionName(e, 'limit()', 'Query.limit()');
      }
    }
  }, {
    key: "limitToLast",
    value: function limitToLast(n) {
      try {
        return new Query(this.firestore, query(this._delegate, _limitToLast(n)));
      } catch (e) {
        throw replaceFunctionName(e, 'limitToLast()', 'Query.limitToLast()');
      }
    }
  }, {
    key: "startAt",
    value: function startAt() {
      try {
        return new Query(this.firestore, query(this._delegate, _startAt.apply(void 0, arguments)));
      } catch (e) {
        throw replaceFunctionName(e, 'startAt()', 'Query.startAt()');
      }
    }
  }, {
    key: "startAfter",
    value: function startAfter() {
      try {
        return new Query(this.firestore, query(this._delegate, _startAfter.apply(void 0, arguments)));
      } catch (e) {
        throw replaceFunctionName(e, 'startAfter()', 'Query.startAfter()');
      }
    }
  }, {
    key: "endBefore",
    value: function endBefore() {
      try {
        return new Query(this.firestore, query(this._delegate, _endBefore.apply(void 0, arguments)));
      } catch (e) {
        throw replaceFunctionName(e, 'endBefore()', 'Query.endBefore()');
      }
    }
  }, {
    key: "endAt",
    value: function endAt() {
      try {
        return new Query(this.firestore, query(this._delegate, _endAt.apply(void 0, arguments)));
      } catch (e) {
        throw replaceFunctionName(e, 'endAt()', 'Query.endAt()');
      }
    }
  }, {
    key: "isEqual",
    value: function isEqual(other) {
      return queryEqual(this._delegate, other._delegate);
    }
  }, {
    key: "get",
    value: function get(options) {
      var _this9 = this;
      var query;
      if ((options === null || options === void 0 ? void 0 : options.source) === 'cache') {
        query = getDocsFromCache(this._delegate);
      } else if ((options === null || options === void 0 ? void 0 : options.source) === 'server') {
        query = getDocsFromServer(this._delegate);
      } else {
        query = getDocs(this._delegate);
      }
      return query.then(function (result) {
        return new QuerySnapshot(_this9.firestore, new QuerySnapshot$1(_this9.firestore._delegate, _this9._userDataWriter, _this9._delegate, result._snapshot));
      });
    }
  }, {
    key: "onSnapshot",
    value: function onSnapshot() {
      var _this10 = this;
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      var options = extractSnapshotOptions(args);
      var observer = wrapObserver(args, function (snap) {
        return new QuerySnapshot(_this10.firestore, new QuerySnapshot$1(_this10.firestore._delegate, _this10._userDataWriter, _this10._delegate, snap._snapshot));
      });
      return _onSnapshot(this._delegate, options, observer);
    }
  }, {
    key: "withConverter",
    value: function withConverter(converter) {
      return new Query(this.firestore, converter ? this._delegate.withConverter(FirestoreDataConverter.getInstance(this.firestore, converter)) : this._delegate.withConverter(null));
    }
  }]);
  return Query;
}();
var DocumentChange = /*#__PURE__*/function () {
  function DocumentChange(_firestore, _delegate) {
    _classCallCheck(this, DocumentChange);
    this._firestore = _firestore;
    this._delegate = _delegate;
  }
  _createClass(DocumentChange, [{
    key: "type",
    get: function get() {
      return this._delegate.type;
    }
  }, {
    key: "doc",
    get: function get() {
      return new QueryDocumentSnapshot(this._firestore, this._delegate.doc);
    }
  }, {
    key: "oldIndex",
    get: function get() {
      return this._delegate.oldIndex;
    }
  }, {
    key: "newIndex",
    get: function get() {
      return this._delegate.newIndex;
    }
  }]);
  return DocumentChange;
}();
var QuerySnapshot = /*#__PURE__*/function () {
  function QuerySnapshot(_firestore, _delegate) {
    _classCallCheck(this, QuerySnapshot);
    this._firestore = _firestore;
    this._delegate = _delegate;
  }
  _createClass(QuerySnapshot, [{
    key: "query",
    get: function get() {
      return new Query(this._firestore, this._delegate.query);
    }
  }, {
    key: "metadata",
    get: function get() {
      return this._delegate.metadata;
    }
  }, {
    key: "size",
    get: function get() {
      return this._delegate.size;
    }
  }, {
    key: "empty",
    get: function get() {
      return this._delegate.empty;
    }
  }, {
    key: "docs",
    get: function get() {
      var _this11 = this;
      return this._delegate.docs.map(function (doc) {
        return new QueryDocumentSnapshot(_this11._firestore, doc);
      });
    }
  }, {
    key: "docChanges",
    value: function docChanges(options) {
      var _this12 = this;
      return this._delegate.docChanges(options).map(function (docChange) {
        return new DocumentChange(_this12._firestore, docChange);
      });
    }
  }, {
    key: "forEach",
    value: function forEach(callback, thisArg) {
      var _this13 = this;
      this._delegate.forEach(function (snapshot) {
        callback.call(thisArg, new QueryDocumentSnapshot(_this13._firestore, snapshot));
      });
    }
  }, {
    key: "isEqual",
    value: function isEqual(other) {
      return snapshotEqual(this._delegate, other._delegate);
    }
  }]);
  return QuerySnapshot;
}();
var CollectionReference = /*#__PURE__*/function (_Query) {
  _inherits(CollectionReference, _Query);
  var _super3 = _createSuper(CollectionReference);
  function CollectionReference(firestore, _delegate) {
    var _this14;
    _classCallCheck(this, CollectionReference);
    _this14 = _super3.call(this, firestore, _delegate);
    _this14.firestore = firestore;
    _this14._delegate = _delegate;
    return _this14;
  }
  _createClass(CollectionReference, [{
    key: "id",
    get: function get() {
      return this._delegate.id;
    }
  }, {
    key: "path",
    get: function get() {
      return this._delegate.path;
    }
  }, {
    key: "parent",
    get: function get() {
      var docRef = this._delegate.parent;
      return docRef ? new DocumentReference(this.firestore, docRef) : null;
    }
  }, {
    key: "doc",
    value: function doc(documentPath) {
      try {
        if (documentPath === undefined) {
          // Call `doc` without `documentPath` if `documentPath` is `undefined`
          // as `doc` validates the number of arguments to prevent users from
          // accidentally passing `undefined`.
          return new DocumentReference(this.firestore, _doc(this._delegate));
        } else {
          return new DocumentReference(this.firestore, _doc(this._delegate, documentPath));
        }
      } catch (e) {
        throw replaceFunctionName(e, 'doc()', 'CollectionReference.doc()');
      }
    }
  }, {
    key: "add",
    value: function add(data) {
      var _this15 = this;
      return addDoc(this._delegate, data).then(function (docRef) {
        return new DocumentReference(_this15.firestore, docRef);
      });
    }
  }, {
    key: "isEqual",
    value: function isEqual(other) {
      return refEqual(this._delegate, other._delegate);
    }
  }, {
    key: "withConverter",
    value: function withConverter(converter) {
      return new CollectionReference(this.firestore, converter ? this._delegate.withConverter(FirestoreDataConverter.getInstance(this.firestore, converter)) : this._delegate.withConverter(null));
    }
  }]);
  return CollectionReference;
}(Query);
function castReference(documentRef) {
  return _cast(documentRef, DocumentReference$1);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
/**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a list
 * of field names (referring to a nested field in the document).
 */
var FieldPath = /*#__PURE__*/function () {
  /**
   * Creates a FieldPath from the provided field names. If more than one field
   * name is provided, the path will point to a nested field in a document.
   *
   * @param fieldNames - A list of field names.
   */
  function FieldPath() {
    _classCallCheck(this, FieldPath);
    for (var _len6 = arguments.length, fieldNames = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      fieldNames[_key6] = arguments[_key6];
    }
    this._delegate = _construct(FieldPath$1, fieldNames);
  }
  _createClass(FieldPath, [{
    key: "isEqual",
    value: function isEqual(other) {
      other = getModularInstance(other);
      if (!(other instanceof FieldPath$1)) {
        return false;
      }
      return this._delegate._internalPath.isEqual(other._internalPath);
    }
  }], [{
    key: "documentId",
    value: function documentId() {
      /**
       * Internal Note: The backend doesn't technically support querying by
       * document ID. Instead it queries by the entire document name (full path
       * included), but in the cases we currently support documentId(), the net
       * effect is the same.
       */
      return new FieldPath(_FieldPath.keyField().canonicalString());
    }
  }]);
  return FieldPath;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FieldValue = /*#__PURE__*/function () {
  function FieldValue(_delegate) {
    _classCallCheck(this, FieldValue);
    this._delegate = _delegate;
  }
  _createClass(FieldValue, [{
    key: "isEqual",
    value: function isEqual(other) {
      return this._delegate.isEqual(other._delegate);
    }
  }], [{
    key: "serverTimestamp",
    value: function serverTimestamp() {
      var delegate = _serverTimestamp();
      delegate._methodName = 'FieldValue.serverTimestamp';
      return new FieldValue(delegate);
    }
  }, {
    key: "delete",
    value: function _delete() {
      var delegate = deleteField();
      delegate._methodName = 'FieldValue.delete';
      return new FieldValue(delegate);
    }
  }, {
    key: "arrayUnion",
    value: function arrayUnion() {
      var delegate = _arrayUnion.apply(void 0, arguments);
      delegate._methodName = 'FieldValue.arrayUnion';
      return new FieldValue(delegate);
    }
  }, {
    key: "arrayRemove",
    value: function arrayRemove() {
      var delegate = _arrayRemove.apply(void 0, arguments);
      delegate._methodName = 'FieldValue.arrayRemove';
      return new FieldValue(delegate);
    }
  }, {
    key: "increment",
    value: function increment(n) {
      var delegate = _increment(n);
      delegate._methodName = 'FieldValue.increment';
      return new FieldValue(delegate);
    }
  }]);
  return FieldValue;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firestoreNamespace = {
  Firestore: Firestore,
  GeoPoint: GeoPoint,
  Timestamp: Timestamp,
  Blob: Blob,
  Transaction: Transaction,
  WriteBatch: WriteBatch,
  DocumentReference: DocumentReference,
  DocumentSnapshot: DocumentSnapshot,
  Query: Query,
  QueryDocumentSnapshot: QueryDocumentSnapshot,
  QuerySnapshot: QuerySnapshot,
  CollectionReference: CollectionReference,
  FieldPath: FieldPath,
  FieldValue: FieldValue,
  setLogLevel: setLogLevel,
  CACHE_SIZE_UNLIMITED: CACHE_SIZE_UNLIMITED
};
/**
 * Configures Firestore as part of the Firebase SDK by calling registerComponent.
 *
 * @param firebase - The FirebaseNamespace to register Firestore with
 * @param firestoreFactory - A factory function that returns a new Firestore
 *    instance.
 */
function configureForFirebase(firebase, firestoreFactory) {
  firebase.INTERNAL.registerComponent(new Component('firestore-compat', function (container) {
    var app = container.getProvider('app-compat').getImmediate();
    var firestoreExp = container.getProvider('firestore').getImmediate();
    return firestoreFactory(app, firestoreExp);
  }, 'PUBLIC').setServiceProps(Object.assign({}, firestoreNamespace)));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Registers the main Firestore build with the components framework.
 * Persistence can be enabled via `firebase.firestore().enablePersistence()`.
 */
function registerFirestore(instance) {
  configureForFirebase(instance, function (app, firestoreExp) {
    return new Firestore(app, firestoreExp, new IndexedDbPersistenceProvider());
  });
  instance.registerVersion(name, version);
}
registerFirestore(firebase);
export { registerFirestore };